// API Configuration
// Replace 'your_api_key_here' with your actual Google Places API key
export const API_CONFIG = {
  GOOGLE_PLACES_API_KEY: 'AIzaSyC7GNsyT5hqzHyeOGwBMRlXh0jmDc-BBJo',
  // Add other API keys here as needed
  GOOGLE_MAPS_API_KEY: '',
  MOZ_ACCESS_ID: '',
  MOZ_SECRET_KEY: '',
  WAPPALYZER_API_KEY: '',
  YELP_API_KEY: '',
  CLEARBIT_API_KEY: ''
};

// Fallback to environment variables if available
export const getApiKey = (keyName: keyof typeof API_CONFIG): string => {
  // Try environment variable first
  const envKey = import.meta.env[`REACT_APP_${keyName}`] as string;
  if (envKey) {
    return envKey;
  }
  
  // Fallback to config
  return API_CONFIG[keyName] || '';
};
